import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalCloseButton } from "@air/primitive-modal";
import Image from "next/image";
import { memo } from "react";
export const NoPlanUpgradePermissionModal = /*#__PURE__*/ memo((param)=>{
    let { onClose } = param;
    return /*#__PURE__*/ _jsx(Modal, {
        isOpen: true,
        onDismiss: onClose,
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col items-center",
            children: [
                /*#__PURE__*/ _jsx(ModalCloseButton, {
                    className: "self-end",
                    onClick: onClose
                }),
                /*#__PURE__*/ _jsx(Image, {
                    alt: "Upgrade to Air Pro",
                    className: "mb-4",
                    height: 170,
                    src: "/assets/illustrations/upgrade-to-pro.svg",
                    width: 170
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mb-2 text-24 font-semibold text-blue-10",
                    children: "Upgrade to Air Pro"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-center text-16 text-grey-11",
                    children: "Contact the admin of your workspace to upgrade your plan to Pro"
                })
            ]
        })
    });
});
NoPlanUpgradePermissionModal.displayName = "NoPlanUpgradePermissionModal";
